import React, { useState } from 'react';
import './ProductCard.css';
import { useCart } from '../../context/CartContext';
import Button from '../UI/Button';

const ProductCard = ({ product, setRoute }) => {
  const [activeTab, setActiveTab] = useState('description');
  const [quantity, setQuantity] = useState(1);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    addToCart(product, quantity);
    setQuantity(1); // Reset quantity after adding
  };

  const incrementQuantity = () => {
    setQuantity(prev => prev + 1);
  };

  const decrementQuantity = () => {
    setQuantity(prev => (prev > 1 ? prev - 1 : 1));
  };

  const handleRecipeClick = () => {
    setRoute('recipes');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="product-card">
      {product.featured && <span className="featured-badge">Most Popular</span>}
      
      <div className="product-image-container">
        <img
          src={product.image}
          alt={product.name}
          className="product-image"
        />
      </div>

      {/* Pill Tab Menu */}
      <div className="product-tabs">
        <button 
          className={`product-tab ${activeTab === 'description' ? 'active' : ''}`}
          onClick={() => setActiveTab('description')}
        >
          Description
        </button>
        <button 
          className={`product-tab ${activeTab === 'ingredients' ? 'active' : ''}`}
          onClick={() => setActiveTab('ingredients')}
        >
          Ingredients
        </button>
      </div>

      <div className="product-info">
        <h3 className="product-name">{product.name}</h3>
        <p className="product-price">${product.price.toFixed(2)}</p>

        {/* Tab Content */}
        <div className="product-tab-content">
          {activeTab === 'description' ? (
            <p className="product-description">{product.description}</p>
          ) : (
            <div className="product-ingredients">
              <div className="nutrition-facts">
                <h4 className="nutrition-title">Nutrition Facts</h4>
                <div className="nutrition-serving">
                  <p><strong>Serving Size:</strong> {product.nutritionFacts.servingSize}</p>
                  <p><strong>Servings Per Container:</strong> {product.nutritionFacts.servingsPerContainer}</p>
                </div>
                <div className="nutrition-calories">
                  <strong>Calories</strong>
                  <strong>{product.nutritionFacts.calories}</strong>
                </div>
                <div className="nutrition-nutrients">
                  {product.nutritionFacts.nutrients.map((nutrient, idx) => (
                    <div key={idx} className="nutrition-row">
                      <span>{nutrient.name} {nutrient.amount}</span>
                      {nutrient.dailyValue && <span>{nutrient.dailyValue}</span>}
                    </div>
                  ))}
                </div>
              </div>
              <div className="ingredients-section">
                <h4><i className="fas fa-list"></i> Ingredients</h4>
                <p>{product.ingredients}</p>
              </div>
              <div className="allergens-section">
                <h4><i className="fas fa-exclamation-triangle"></i> Contains</h4>
                <p>{product.allergens}</p>
              </div>
            </div>
          )}
        </div>

        {product.featuredRecipe && (
          <div className="recipe-inspiration-badge" onClick={handleRecipeClick}>
            <div className="recipe-badge-content">
              <div className="recipe-badge-icon">
                <i className="fas fa-utensils"></i>
              </div>
              <div className="recipe-badge-text">
                <span className="recipe-badge-label">Recipe Idea</span>
                <span className="recipe-badge-title">{product.featuredRecipe.title}</span>
              </div>
              <i className="fas fa-arrow-right recipe-badge-arrow"></i>
            </div>
          </div>
        )}

        {!product.inStock && (
          <p className="out-of-stock">Out of Stock</p>
        )}

        {product.inStock && (
          <div className="product-actions">
            <div className="quantity-selector">
              <button 
                onClick={decrementQuantity}
                aria-label="Decrease quantity"
                className="qty-btn"
              >
                <i className="fas fa-minus"></i>
              </button>
              <span className="quantity">{quantity}</span>
              <button 
                onClick={incrementQuantity}
                aria-label="Increase quantity"
                className="qty-btn"
              >
                <i className="fas fa-plus"></i>
              </button>
            </div>

            <Button
              variant="primary"
              onClick={handleAddToCart}
              className="add-to-cart-btn"
              icon={<i className="fas fa-shopping-cart"></i>}
            >
              Add to Cart
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
